// here we are importing our Axios dependency
import axios from "axios";

//const baseDomain = "http://localhost:8080";
//   const baseURL = `${baseDomain}/api`;


const baseDomain = 'https://bosspourapi.azurewebsites.net';
const baseURL = `${baseDomain}/api`;

const apiClient = axios.create({ baseURL });

export default {
    getBrewResultsForCompetition(competitionId) {
        return apiClient.get(`/GetBrewResults?competitionId=${competitionId}`);
    },
    getBrewsForCompetition(competitionId) {
        return apiClient.get(`/GetBrews?competitionId=${competitionId}`);
    },
    getKeyWords(payload) {
        return apiClient.post("/GetKeyWords", payload);
    },
    getPreResult(payload) {
        return apiClient.post("/GetPreResult", payload);
    },
    forceCompetitionResult(payload) {
        return apiClient.post("/CalculateCompetitionResult", payload);
    },
    archiveCompetition(payload) {
        return apiClient.post("/ArchiveCompetition", payload);
    },
    closeCompetition(payload) {
        return apiClient.post("/CloseCompetition", payload);
    },
    publishCompetitionResult(payload) {
        return apiClient.post("/PublishCompetitionResult", payload);
    },
    unpublishCompetitionResult(payload) {
        return apiClient.post("/UnpublishCompetitionResult", payload);
    },
    openCompetition(payload) {
        return apiClient.post("/OpenCompetition", payload);
    },
    getCompetitionManagement(payload) {
        return apiClient.post("/GetCompetitionManagement", payload);
    },
    sendInvites(payload) {
        return apiClient.post("/SendInvites", payload);
    },
    getAllCompetitions() {
        return apiClient.get(`/GetCompetitions`);
    },
    getCompetition(competitionId) {
        return apiClient.get(`/GetCompetition?id=${competitionId}`);
    },
    addVote(payload) {
        console.log(payload)
        return apiClient.post("/AddVotes", payload);
    },
    getVotes(payload) {
        return apiClient.post("/GetVotes", payload);
    },
    addBayesianVote(payload) {
        return apiClient.post("/AddBayesianVote", payload);
    },
    addSingleVote(payload) {
        return apiClient.post("/AddSingleVote", payload);
    },
    deleteBayesianVote(payload) {
        return apiClient.post("/DeleteBayesianVote", payload);
    },
    deleteSingleVote(payload) {
        return apiClient.post("/DeleteSingleVote", payload);
    },
    deleteBrew(payload, brewId) {
        var url = `/DeleteBrew?id=${brewId}`;
        return apiClient.post(url, payload);
    },
    getBayesianVotesByUser(payload) {
        return apiClient.post("/GetBayesianVotesByUser", payload);
    },
    getSingleVotesByUser(payload) {
        return apiClient.post("/GetSingleVotesByUser", payload);
    },
    getBrewDisplayHtml(competitionId, displayNumber) {
        var url = `/GetBrewDisplayHtml?competitionId=${competitionId}`;

        if (displayNumber) {
            url = url + `&displayNumber=${displayNumber}`;
        }
        return apiClient.get(url);
    },
    getVoteKeyByLogin(payload) {
        return apiClient.post("/GetVoteKeyByLogin", payload);
    },
    addBrewersChoiceVote(payload) {
        return apiClient.post("/AddBrewersChoiceVote", payload);
    },
    deleteBrewersChoiceVote(payload) {
        return apiClient.post("/DeleteBrewersChoiceVote", payload);
    },
    getBrewersChoiceVoteByUser(payload) {
        return apiClient.post("/GetBrewersChoiceVoteByUser", payload);
    },
    getBrewersChoiceResult(payload) {
        return apiClient.post("/GetBrewersChoiceResult", payload);
    },
    reserveKeyword(payload) {
        return apiClient.post("/ReserveKeyword", payload);
    }
};